import React from "react";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ChatIcon from "@material-ui/icons/Chat";
import { useStyles } from "../SideDrawer/NavListItems/styles";
import useNotificationFeedbackSettings from "../../hooks/useNotificationFeedbackSettings";
import {
  shouldShowFeedbackButton,
  getFeedbackLabel,
} from "../../utils/notificationFeedbackVisibility";

const FeedbackButton = ({ isIssueValidationOnlyUser }) => {
  const classes = useStyles();
  const { settings, loading, error } = useNotificationFeedbackSettings();

  const shouldShow = shouldShowFeedbackButton({
    feedbackEnabled: settings?.feedbackEnabled,
    feedbackUrl: settings?.feedbackUrl,
    isIssueValidationOnlyUser,
    hasSettings: !loading && !error && settings != null,
  });

  if (!shouldShow) return null;

  const label = getFeedbackLabel(settings?.feedbackLabel);

  const handleClick = () => {
    window.open(settings.feedbackUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <ListItem
      button
      className={`${classes.navLink} feedback-button`}
      onClick={handleClick}
      aria-label={label}
    >
      <ListItemIcon>
        <ChatIcon className={classes.navLink} fontSize="large" />
      </ListItemIcon>
      <ListItemText primary={label} />
    </ListItem>
  );
};

export default FeedbackButton;
